import { z } from "zod";

export const appWebhookEventKeySchema = z.enum([
  "order.paid",
  "order.refunded",
  "membership.granted",
  "membership.canceled",
]);
export type AppWebhookEventKey = z.infer<typeof appWebhookEventKeySchema>;

export const APP_WEBHOOK_EVENT_KEYS = appWebhookEventKeySchema.options;

export const appWebhookDeliveryStatusSchema = z.enum(["pending", "delivered", "failed"]);
export type AppWebhookDeliveryStatus = z.infer<typeof appWebhookDeliveryStatusSchema>;

const timestamp = z.string().datetime();
const httpsOrLocalUrl = z.string().trim().max(512).refine((value) => {
  try {
    const url = new URL(value);
    if (url.protocol === "https:") return true;
    return url.protocol === "http:" && (url.hostname === "127.0.0.1" || url.hostname === "localhost");
  } catch {
    return false;
  }
}, "回调地址必须是 https，或本机 http://127.0.0.1 / localhost");

export const adminAppWebhookEndpointSchema = z.object({
  appId: z.string().min(1),
  url: z.string(),
  enabled: z.boolean(),
  events: z.array(appWebhookEventKeySchema),
  secretConfigured: z.boolean(),
  version: z.number().int().nonnegative(),
  updatedAt: timestamp.nullable(),
  revealedSecret: z.string().nullable().optional(),
});
export type AdminAppWebhookEndpoint = z.infer<typeof adminAppWebhookEndpointSchema>;

export const adminAppWebhookUpsertSchema = z.object({
  url: httpsOrLocalUrl,
  enabled: z.boolean(),
  events: z.array(appWebhookEventKeySchema).min(1),
  secret: z.string().trim().max(256).optional(),
  expectedVersion: z.number().int().nonnegative(),
}).strict();
export type AdminAppWebhookUpsertInput = z.infer<typeof adminAppWebhookUpsertSchema>;

export const adminAppWebhookDeliverySchema = z.object({
  id: z.string().min(1),
  appId: z.string().min(1),
  eventKey: appWebhookEventKeySchema,
  occurrenceKey: z.string().min(1),
  status: appWebhookDeliveryStatusSchema,
  attemptCount: z.number().int().nonnegative(),
  httpStatus: z.number().int().nullable(),
  lastError: z.string().nullable(),
  payload: z.record(z.string(), z.unknown()),
  nextAttemptAt: timestamp.nullable(),
  deliveredAt: timestamp.nullable(),
  createdAt: timestamp,
  updatedAt: timestamp,
});
export type AdminAppWebhookDelivery = z.infer<typeof adminAppWebhookDeliverySchema>;

export const adminAppWebhookDeliveryListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).max(10_000).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
export type AdminAppWebhookDeliveryListQuery = z.infer<typeof adminAppWebhookDeliveryListQuerySchema>;

export const adminAppWebhookDeliveryListResultSchema = z.object({
  items: z.array(adminAppWebhookDeliverySchema),
  total: z.number().int().nonnegative(),
});
export type AdminAppWebhookDeliveryListResult = z.infer<typeof adminAppWebhookDeliveryListResultSchema>;
